/**
 * Formulario de contacto público.
 *
 * Envía la información al endpoint `/api/contact`, que a su vez reenvía el
 * contenido por Mailgun desde backend.
 */
import React, { useState } from "react";
import "./ContactForm.scss";
import runtimeConfig from "../config/runtimeConfig";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${runtimeConfig.apiBaseUrl}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      await response.json();
      if (response.ok) {
        setStatus("success");
        setFormData({ nombre: "", email: "", telefono: "", mensaje: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error al enviar el formulario", error);
      setStatus("error");
    }
  };

  return (
    <section id="contacto" className="contact-form">
      <div className="contenedor-contacto">
        <h2>
          ¿No sabes cuál es el plan ideal para ti? <br />
          <span>Contáctanos, nosotras podemos ayudarte.</span>
        </h2>

        <div className="contenedor-form">
          <form onSubmit={handleSubmit}>
            <label>Nombre</label>
            <input
              className="first-input"
              type="text"
              placeholder="Nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
            />
            <label>E-mail</label>
            <input
              type="email"
              placeholder="Correo"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            <label>Número telefónico</label>
            <input
              type="tel"
              placeholder="Número de teléfono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
            />
            <label>Déjanos tu mensaje</label>
            <textarea
              placeholder="Déjanos tu mensaje"
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChange}
            ></textarea>
            <button className="btn-accion" type="submit">
              Enviar
            </button>
          </form>
          <img src="/assets/images/contactoImg.png" alt="Fitness life" />
        </div>
        {status === "success" && <p>Mensaje enviado correctamente.</p>}
        {status === "error" && (
          <p>Hubo un error al enviar el mensaje. Inténtalo de nuevo.</p>
        )}

        <div className="footer">
          <div className="datos-contacto">
            <ul>
              <li>
                <img src="/assets/images/phone.png" alt="Fitness life" />
                +52 443 145 2567
              </li>
              <li>
                <a href="mailto:hola@mentfull.com">
                  <img src="/assets/images/envelope.png" alt="Fitness life" />
                  hola@mentfull.com
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <a href="https://www.instagram.com/mentfullmx/">
                  <img src="/assets/images/instagram.png" alt="Fitness life" />
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/mentfullmx">
                  <img src="/assets/images/facebook.png" alt="Fitness life" />
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          <div className="copyright">
            <p>
              Copyright &copy;
              <script>document.write(new Date().getFullYear());</script>
              All rights reserved to Mentful Mx| Progressive Web App developed
              By
              <a
                href="https://www.facebook.com/VectorVisualMexico"
                target="_blank"
                rel="noreferrer"
              >
                &nbsp;Vector Visual MX
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
